import { z } from "zod";

import { LocalTimeSchema } from "./daily-goal";

export const PartnerAlertChannelSchema = z.enum(["PUSH", "EMAIL", "BOTH"]);

export const NotificationPreferencesSchema = z.object({
  morningReminderEnabled: z.boolean(),
  morningReminderTime: LocalTimeSchema.nullable(),
  deepWorkReminderEnabled: z.boolean(),
  deepWorkReminderTime: LocalTimeSchema.nullable(),
  shutdownReminderEnabled: z.boolean(),
  shutdownReminderTime: LocalTimeSchema.nullable(),
  weeklySummaryEnabled: z.boolean(),
  weeklySummaryDay: z.number().int().min(0).max(6).nullable(),
  weeklySummaryTime: LocalTimeSchema.nullable(),
  partnerAlertsEnabled: z.boolean(),
  partnerAlertChannel: PartnerAlertChannelSchema,
});

export const UpdateNotificationPreferencesSchema = NotificationPreferencesSchema.partial();

export const NotificationPreferencesResponseSchema = z.object({
  preferences: NotificationPreferencesSchema,
});

export const PushTokenPlatformSchema = z.enum(["ios", "android", "web"]);

export const RegisterPushTokenSchema = z.object({
  token: z.string().trim().min(1).max(400),
  platform: PushTokenPlatformSchema,
});

export type PartnerAlertChannel = z.infer<typeof PartnerAlertChannelSchema>;
export type NotificationPreferences = z.infer<typeof NotificationPreferencesSchema>;
export type UpdateNotificationPreferencesInput = z.infer<
  typeof UpdateNotificationPreferencesSchema
>;
export type NotificationPreferencesResponse = z.infer<
  typeof NotificationPreferencesResponseSchema
>;
export type PushTokenPlatform = z.infer<typeof PushTokenPlatformSchema>;
export type RegisterPushTokenInput = z.infer<typeof RegisterPushTokenSchema>;
